import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 8AE7213F-00BD-40D9-A524-2CCB60511BBA
 * name garage-open-variant
 * version: 4.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/garage-open-variant.svg
 * tags
 * - Home Automation 
 */
export const GarageOpenVariantIcon = createSvgIcon(<><path d="M22 9V20H20V11H4V20H2V9L12 5L22 9M19 12H5V14H19V12Z" /></>, 'GarageOpenVariantIcon');
export default GarageOpenVariantIcon